import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import forIn from 'lodash/forIn'
import forEach from 'lodash/forEach'
import cloneDeep from 'lodash/cloneDeep'

/**
 * Проверяет имеется ли в объекте фильтров, значения фильтров пфс.
 * @param {(Object|null)} filterObj Объект с фильтрами.
 * @param {Object} pfsFilter Объект с фильтром пфс.
 * @returns {boolean} Признак наличия пфс фильтра в объекте фильтров.
 */
export const filterObjHasAppliedPFS = (filterObj, pfsFilter) => {
  let result = true
  if (isObject(filterObj) && isObject(pfsFilter)) {
    const currentFilterObj = parseNumRangeFilterObjValues(cloneDeep(filterObj))
    forIn(pfsFilter, (pfsFilterValue, pfsFilterKey) => {
      if (isArray(pfsFilterValue) && isArray(currentFilterObj[pfsFilterKey])) {
        result = hasFilterValuesEntries(currentFilterObj[pfsFilterKey], pfsFilterValue)
        return result
      } else {
        result = false
        return false
      }
    })
    return result
  } else {
    return false
  }
}

/**
 * Проверяет значения фильтров на совпадения.
 * @param {Array} values Значения фильтра, в котором будут проверятся совпадения.
 * @param {Array} entriesValues Значения фильтра, которые будут проверятся на совпадения.
 * @returns {boolean} Признак наличия совпадений.
 */
export const hasFilterValuesEntries = (values, entriesValues) => {
  let result = true
  const stringifyValues = values.map(String)
  forEach(entriesValues, value => {
    if (!stringifyValues.includes(String(value))) {
      result = false
      return false
    }
  })
  return result
}

/**
 * Проходит по объекту фильтров, находит NumRange фильтры, парсит их.
 * @param {Object} filterObj Объект фильтров.
 * @returns {Object} Объект фильтров.
 */
export const parseNumRangeFilterObjValues = filterObj => {
  forIn(filterObj, (filterValue, filterKey) => {
    if (isArray(filterValue) && isNumRangeFilter(filterValue)) {
      try {
        filterObj[filterKey] = JSON.parse(filterObj[filterKey])
      } catch (e) {}
    }
  })
  return filterObj
}

/**
 * Проверяет строку на содержание скобок '[]', является признаком фильтра NumRange.
 * @param {(string|number)} value Значение фильтра.
 * @returns {boolean} Признак совпадения - true если является NumRange.
 */
export const isNumRangeFilter = value => {
  return /\[.*\]/.test(String(value))
}
